// Conversation content for "Show all projects" topic
// Edit this file to update the conversation content

const projectsConversation = {
  id: 'projects',
  title: 'All Projects',
  messages: [
    "I almost always have a few side projects in rotation. It’s how I keep my execution muscles sharp.",
    "",
    "As a PM with a background in data science and engineering, I love building end-to-end. It lets me feel real user pain myself and helps me evolve my POV on what actually matters.",
    "",
    "When I’m toying with an idea, I’ll 'vibe code' a prototype to feel out the UX before I commit to anything deeper.",
    "",
    "At home, that’s looked like:",
    "",
    "• SighedKick — My personal GenAI lab where I explore use-case-specific UX patterns and applied AI workflows.",
    "",
    "• EmptyMyInbox — An iOS app for managing inbox overload. I built it as a playground to explore agentic experiences and get to inbox zero.",
    "",
    "I bring that same prototype-first energy to work, too.",
    "",
    "At Credit Karma, I’ve built 'Future Feed' demo apps—lightweight prototypes used to rally stakeholders around where our Discovery surfaces should go next.",
    "",
    "My process is pretty consistent: I tear down existing products, map how different teams frame the same problem, and then build my own take from systems → UX → messaging.",
    "",
    "You’ll find a mix of these projects on this site. Some are polished, some are obviously v0.1—but they all represent how I think and build for fun."
  ]
};

export default projectsConversation;





